import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const withdrawExplanationHandler = restHandlerFactory(
  '/trials/{trial_uid}/explanation_revisions/{explanation_revision_uid}/withdraw',
  'post',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
